import React, { Component } from 'react';
import { connect } from 'react-redux';
import LightBoxModal from '../Components/LightBoxModal';
import { setCurrentIndex, show, previous, next } from '../Actions/LightboxImages.action';

class LightBoxModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            activeIndex : 0
        };
    }

    setVisibility(index) {
        this.setState({
            isVisible: !this.state.isVisible,
            activeIndex: index,
        });
    }
    onClose() {
        this.setState({
            isVisible: false,
        });
    }
    render() {
        return <LightBoxModal {...this.props} isOpen={this.state.isVisible} setVisibility={(index) => this.setVisibility(index)}  onClose={() => this.onClose()} activeIndex={this.state.activeIndex} />;
    }
}
const mapStateToProps = (state) => {
    return {
        isOpen: state.lightboxImages.visible,
        currentImage: state.lightboxImages.index,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onClose: () => dispatch(show(false)),
        onClickNext: () => dispatch(next()),
        onClickPrev: () => dispatch(previous()),
        onClickThumbnail: (index) => {
            dispatch(setCurrentIndex(index));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LightBoxModalContainer);
